export { default } from 'Catalog/Availability/ProductAvailabilityContainer'
export { default as IfAvailable } from 'Catalog/Availability/IfAvailable'



// WEBPACK FOOTER //
// ./src/Catalog/Availability/index.js